<div
	ucUniImpressionGA
	[uniId]="uni().id"
	[uniName]="uni().name"
	[product]="product()"
	[ugSearchOrderPosition]="ugso()"
	[cleSearchOrderPosition]="cleso()"
	class="overflow-hidden text-left bg-white border border-gray-200 rounded-lg shadow-xs"
>
	@if (uni().profile?.cover_image && uni().slug) {
		<a
			[routerLink]="['/universities', uni().slug]"
			class="relative block w-full h-56"
		>
			<img
				[ngSrc]="uni().profile?.cover_image | cdn"
				fill
				class="object-cover bg-center bg-no-repeat focus:outline-none"
				[attr.alt]="'Photo of ' + uni.name"
			/>
		</a>
	}
	<div class="p-5">
		<p class="text-xl font-bold text-gray-900">
			<a
				[routerLink]="
					product() === 'undergraduate'
						? ['/universities', uni().slug]
						: ['/universities', uni().slug, product()]
				"
				class="swiper-no-swiping"
			>
				<span class="text-xl font-bold text-gray-900">
					{{ uni().short_name }}
				</span>
			</a>
		</p>
		@if (uni().courses_count) {
			<p class="mt-1 text-sm text-gray-500">{{ uni().courses_count }} courses</p>
		}
		@if (uni().profile?.external_url) {
			<uc-recommended-visit-website-btn
				customStyles="w-full mt-4"
				[product]="product()"
				[componentName]="componentName"
				[uniId]="uni().id"
				[uniName]="uni().name"
				[externalUrl]="uni().profile?.external_url!"
				[searchOrderPosition]="uni().order"
				[privacyPolicyUrl]="uni().privacy_policy_url"
			/>
		}
	</div>
</div>
